export default {
  view: "查看",
  recharge: "充值",
  remark: "备注",
  status: "状态",
  sort: "排序",
  enable: "启用",
  disable: "禁用",
  show: "显示",
  hide: "隐藏",
  export: "导出",
  batchPass: "批量通过",
  batchReject: "批量拒绝",
  batchDelete: "批量删除",
  pass: "通过",
  reject: "拒绝",
  online: "在线",
  offline: "离线",
  all: "全部",
  today: "今",
  total: "总",
  paid: "已",
  pending: "待",
  male: "男",
  female: "女",
  certified: "已认证",
  notCertified: "未认证",
  reviewing: "审核中",
  authRejected: "认证拒绝",
  paidBond: "已缴纳",
  regTime: "注册时间",
  addTime: "添加时间",
  contact: "联系方式",
  realName: "真实姓名",
  account: "账号",
  phone: "手机号",
  storeNo: "商家编号",
  merchantNo: "商家编号：",
  rechargeAmount: "充值金额",
  rechargeAmountPh: "请输入充值金额",
  remarkPh: "请输入备注",
  rechargeDialog: "充值",
  pricingRule: "计费规则",
  orderCountToday: "接单次数(单)",
  orderCountDispatch: "发单次数(单)",
  balance: "账户余额(元)",
  withdrawable: "可提现余额（元）",
  bond: "保证金",
  workStatus: "接单状态",
  riderStatus: "骑手状态",
  riderAccount: "骑手账号",
  riderLevel: "骑手等级",
  todayRank: "今日排行",
  weekRank: "本周排行",
  monthRank: "本月排行",
  orderCount: "接单数",
  payAmount: "支付金额",
  todayOrdersCol: "今日订单",
  merchantName: "商家名称",
  merchantNamePh: "请输入商家名称",
  merchantCodePh: "请输入商家编号",
  storeAddress: "商家地址",
  storeApiInfo: "商户Api信息",
  cancelBtn: "取消",
  okBtn: "确定",
};
